<template>
  <OrderTestDialog
    :is-show-dialog="isShowDialog"
    :title="dialogTitle"
    :show-footer="true"
    @close="$emit('close')"
  >
    <div class="duplicate-genetic-test-content">
      <div v-if="testNameList.length > 1" class="test-names-list">
        <p v-for="(name, index) in testNameList" :key="index" class="test-name-item">
          {{ name }}
        </p>
      </div>
      <p v-else class="test-name">{{ testNameList[0] }}</p>
      <p class="message">{{ duplicateMessage }}</p>
    </div>

    <template v-slot:buttons>
      <div class="button-container">
        <button @click="handleConfirm" class="confirm-btn">
          {{ showRemoveButton ? $t("OrderPage[\"Remove genetic test\"]") : $t("OrderPage[\"Confirm\"]") }}
        </button>
      </div>
    </template>
  </OrderTestDialog>
</template>

<script>
import OrderTestDialog from "../../../components/OrderTestDialog.vue";

export default {
  emits: ["close", "confirm"],
  components: {
    OrderTestDialog
  },

  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    testNameList: {
      type: Array,
      default: () => []
    },
    showRemoveButton: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    dialogTitle() {
      return this.$t("OrderPage[\"Duplicate Genetic Test\"]");
    },

    duplicateMessage() {
      if (this.testNameList.length > 1) {
        return this.$t("OrderPage[\"These genetic tests were already ordered for this patient, so they can't be added again.\"]");
      }
      return this.$t("OrderPage[\"This genetic test was already ordered for this patient, so it can't be added again.\"]");
    }
  },

  methods: {
    handleConfirm() {
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped>
.duplicate-genetic-test-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.test-names-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
}

.test-name-item {
  font-weight: 500;
  font-size: 15px;
  color: #161616;
  margin: 0;
  padding: 0;
}

.test-name {
  font-weight: 600;
  font-size: 16px;
  color: #161616;
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.message {
  font-size: 14px;
  color: #5f5f5f;
  margin: 0;
  line-height: 1.5;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.confirm-btn {
  border-radius: 4px;
  background: #20A8C3;
  color: #FFFFFF;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.429px;
  padding: 8px 32px;
  border: none;
  cursor: pointer;
}

.confirm-btn:hover {
  background: #1a8fa8;
}
</style>
